import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

type ResetValuesOnObjectTitleChangeOptions = {
  valueNameInputName: string
  objectValueInputName: string
  fieldTypeInputName: string
  formatDateInputName: string
  valueTypeInputName: string
  objectValuePathArrayName: string
}

export const useResetValuesOnObjectTitleChange = ({
  valueNameInputName,
  objectValueInputName,
  fieldTypeInputName,
  formatDateInputName,
  valueTypeInputName,
  objectValuePathArrayName,
}: ResetValuesOnObjectTitleChangeOptions) => {
  const {
    setValue,
    watch,
    formState: { isDirty },
  } = useFormContext()

  const watchedObject = watch('object')

  useEffect(() => {
    if (isDirty) {
      setValue(valueNameInputName, null)
      setValue(objectValueInputName, null)
      setValue(fieldTypeInputName, null)
      setValue(formatDateInputName, null)
      setValue(valueTypeInputName, null)
      setValue(objectValuePathArrayName, [])
    }
  }, [watchedObject])
}
